import React from 'react';
import {connect} from 'react-redux';
import {LoadCompanyEpic} from '../actions/auth.actions';
import { withRouter } from 'react-router-dom'



export const RoleAuthorization = (allowedRoles, WrappedComponent) => {
 
  let mapStateToProps = ({authEndpoint, nav},{match}) => {
    return {
      roles: authEndpoint.roles,
    };
  };
 class WithRoleAuthorization extends React.Component {
    render() {
      let hasAccess = false;
      if (this.props) {
        hasAccess = allowedRoles.reduce((valid, roleName) => {
          return valid || this.props.roles.find(r=>r.RoleName === roleName)
        }, false);
      }

      if (hasAccess) {
        //swallow unused props to stop browser console error
        let { match, location, history, loadingInProgress, staticContext, roles, dispatch, ...rest} = this.props;
        return <WrappedComponent {...rest}/>;
      } else {
        return null;
      }
    }
  }
  return withRouter(connect(mapStateToProps)(WithRoleAuthorization));
}


const Authorization = (allowedFeatures, WrappedComponent) => {

  let mapDispatchToProps = (dispatch) => ({ 
    getCompany: (id) => dispatch(LoadCompanyEpic(id))
  });

  let mapStateToProps = ({authEndpoint, nav},{match}) => {

    let company = null;
    if (authEndpoint.company) 
    {
      company = authEndpoint.companyData;
    } else if (authEndpoint.companyData) {
      if(authEndpoint.companyData._id === nav.selectedCompany) {
        company = authEndpoint.companyData;
      }
    } 
    return {
      loadingInProgress: authEndpoint.fetchInProgress,
      company,
      companyId: authEndpoint.company? authEndpoint.company : nav.selectedCompany
    };
  }
  class WithAuthorization extends React.Component {
    componentDidMount(){
      if (!this.props.loadingInProgress && !this.props.company) {
        this.props.getCompany(this.props.companyId);
      }
    }

    render() {
      let hasAccess = false;
      if (this.props) {
        let company = this.props.company;
      
        if (company){ 
          hasAccess = allowedFeatures.reduce((valid, feature) => {
            return valid || company.features[feature]
          }, true);
        }
      }

      if (hasAccess) {
        //swallow unused props to stop browser console error
        let { match, location, history, loadingInProgress, company, companyId, getCompany, staticContext, ...rest} = this.props;
        return <WrappedComponent {...rest}></WrappedComponent>;
      } else {
        return <WrappedComponent style={{display:'none'}}></WrappedComponent>;
      }
    }
  }
  return withRouter(connect(mapStateToProps, mapDispatchToProps)(WithAuthorization));
}

export default Authorization;


// WEBPACK FOOTER //
// ./src/containers/Authorization.js